import { render, staticRenderFns } from "./theoryTopicsDetail.vue?vue&type=template&id=71048ace&scoped=true"
import script from "./theoryTopicsDetail.vue?vue&type=script&lang=js"
export * from "./theoryTopicsDetail.vue?vue&type=script&lang=js"
import style0 from "./theoryTopicsDetail.vue?vue&type=style&index=0&id=71048ace&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71048ace",
  null
  
)

export default component.exports